import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const CarpetasDigitales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  
  // Estado para almacenar el año y la categoría seleccionada
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Años y enlaces
  const years = [
     { year: 2022, to: '/ControlInterno/CarpetasDigitales/2022' },
    { year: 2023, to: '/ControlInterno/CarpetasDigitales/2023' },
    { year: 2024, to: '/ControlInterno/CarpetasDigitales/2024' },
    { year: 2025, to: '/ControlInterno/CarpetasDigitales/2025' },
  ];

  // Categorías
  const categories = [
    // 2022
    { year: 2022, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2022/Primera_Sesion_Ordinaria_2022.pdf' },
    { year: 2022, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2022/Segunda_Sesion_Ordinaria_2022.pdf' },
    { year: 2022, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2022/Tercera_Sesion_Ordinaria_2022.pdf' },
    { year: 2022, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2022, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2022, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2022, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2022, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2022/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },

    { year: 2023, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2023/Primera_Sesion_Ordinaria_2022.pdf' },
    { year: 2023, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2023/Segunda_Sesion_Ordinaria_2022.pdf' },
    { year: 2023, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2023/Tercera_Sesion_Ordinaria_2022.pdf' },
    { year: 2023, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2023, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2023, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2023, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2023, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2023/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },

    { year: 2024, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2024/Primera_Sesion_Ordinaria_2022.pdf' },
    { year: 2024, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2024/Segunda_Sesion_Ordinaria_2022.pdf' },
    { year: 2024, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2024/Tercera_Sesion_Ordinaria_2022.pdf' },
    { year: 2024, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2024, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2024, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2024, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2024, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2024/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },


    { year: 2025, label: 'Primera Sesión Ordinaria', bgColor: '#691C32', pdfUrl: '/micro/cardigital2025/Primera_Sesion_Ordinaria_2022.pdf' },
    { year: 2025, label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A', pdfUrl: '/micro/cardigital2025/Segunda_Sesion_Ordinaria_2022.pdf' },
    { year: 2025, label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A', pdfUrl: '/micro/cardigital2025/Tercera_Sesion_Ordinaria_2022.pdf' },
    { year: 2025, label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968', pdfUrl:  '/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2025, label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2025, label: 'Capacitaciones',           bgColor: '#746666', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2025, label: 'Control Interno',          bgColor: '#6F5400', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },
    { year: 2025, label: 'Administración de Riesgos',bgColor: '#7F7817', pdfUrl:'/micro/cardigital2025/1.  ACTA CUARTA SESION ORDINARIA 2022 - SECRETARÍA DE CONTRALORÍA.pdf' },

  ];

  // Lógica para manejar la selección de año y categoría
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    // Si la categoría tiene un enlace PDF, se abre el documento
    if (category.pdfUrl) {
      window.open(category.pdfUrl, '_blank');
    }
  };

  return (
    <>
      <HeaderSCI title="CARPETAS DIGITALES Y EVIDENCIAS" />

      <div className="container" style={{ paddingBottom: '60px' }}>
        <div className="row justify-content-center">
          {years.map((y, yIdx) => (
            <div key={yIdx} className="col-lg-3 col-md-6 col-12 mb-5 d-flex flex-column align-items-center">
              {/* Year Icon Header */}
              <Link to={y.to} className="carpetas-year-header-link">
                <div className="carpetas-year-header">
                  <div className="carpetas-year-icon">
                    <i className="fa-regular fa-address-card"></i>
                  </div>
                  <h4 className="carpetas-year-title">Año {y.year}</h4>
                </div>
              </Link>

              {/* List of categories */}
              <div className="w-100 d-flex flex-column align-items-center">
                {categories.filter(c => c.year === y.year).map((c, cIdx) => (
                  <div 
                    key={cIdx}
                    className="carpetas-category-btn"
                    style={{ backgroundColor: c.bgColor }}
                    onClick={() => handleCategoryClick(c)}
                  >
                    {c.label}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CarpetasDigitales;